/**
 * @file jobSearchInitialQuery.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 01, 2026 14:43
 */
import { call, put, takeLeading } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    JOB_SEARCH_INITIAL_QUERY_REQUEST,
    jobSearchInitialQuerySuccess,
    jobSearchInitialQueryFailure,
} from 'src/store/actions/job.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';

import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi() {
    const url = '/job/search/initialQuery';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga() {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(jobSearchInitialQuerySuccess(resp.payload));

    } catch (error) {

        yield put(jobSearchInitialQueryFailure(error));

        handleSagaErrors(error);

    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLeading(JOB_SEARCH_INITIAL_QUERY_REQUEST, createRequestSaga);
}
